<cfp-self-onboarding-layout>
  @if (isRegistrationClosed) {
    <cfp-self-onboarding-registration-closed />
  } @else {
    <cfp-self-onboarding-verify-account />
  }
</cfp-self-onboarding-layout>
